import axiosInstance from '../../../../services/axios/axios';
import { then } from '../../../../services/axios/_utility';
import {
	getPaginated,
	postSearch,
} from '../../../../services/axiosAdobe/_api';
import { POST_SEARCH } from '../../../../services/axiosAdobe/_payloads';

/**
 * Asynchronously checks for existence of third-party organization @param organization.
 *
 * @param {string} organization organization of interest.
 * @param {Function} dispatch nullable forwarded Redux store's method for dispatching actions.
 * @returns {Promise} resolved promise possessing existence indication.
 */
export const checkOrganizationExistence = async (organization, dispatch) => {
	return await axiosInstance
		.get('api/RequestFlow/CheckForExistingOrganization', {
			params: {
				organizationName: organization,
			},
		})
		.then(response => then(response, payload => payload, dispatch))
		.catch(ex => {
			throw ex;
		});
};

/**
 * Asynchronously determines if an outstanding agreement for organization @param organization already exists.
 * @param {string} organization organization of interest.
 * @returns {Promise<boolean>} whether an outstanding agreement exists for the organization of interest.
 */
export const checkOrganizationOutstanding = async organization => {
	organization = organization.trim().toLowerCase();
	let payload = {...POST_SEARCH};
	payload.query = organization;
	payload.agreementAssetsCriteria.queryableFields = ['Title'];

	return await getPaginated(
		postSearch,
		'agreementAssetsResults.agreementAssetsResultList',
		payload,
		null,
		true
	)
		.then(arrAgreements => {
			// Adobe Sign performs complex tokenization against "Title" field, easier to perform equality check against returned results than have Adobe Sign search against equality
			return arrAgreements.some(
				agreement =>
					organization === agreement['name'].trim().toLowerCase()
			);
		})
		.catch(ex => {
			throw ex;
		});
};

/**
 * Asynchronously retrieves all active third-party organizations between length @param min and @param max.
 * @param {number} min minimum length to be considered, inclusive.
 * @param {number} max maximum length to be considered, inclusive.
 * @param {Function} dispatch nullable forwarded Redux store's method for dispatching actions.
 * @returns {Promise<string[]>} matching third-party organization names.
 */
export const getOrganizationsByLength = async (min, max, dispatch) => {
	return await axiosInstance
		.get('api/RequestFlow/GetOrganizationsByLength', {
			params: {
				min: min,
				max: max,
			},
		})
		.then(response => then(response, payload => payload, dispatch))
		.catch(ex => {
			throw ex;
		});
};
